import { vehicleSubcategoriesSlice } from "./vehicleSubcategoriesSlice";
import * as defaultActions from "../../../../../redux/_common";

const { actions } = vehicleSubcategoriesSlice;
export const moduleUrl = "/api/appmasterdata/vehicleSubcategories";

export const setValidationErrors = actions.setValidationErrors;

export const getVehicleSubcategories = (params: {}) => defaultActions.getItems(moduleUrl, actions, params);
export const getVehicleSubcategory = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const saveVehicleSubcategory = (item: {}, id: string | null) => defaultActions.saveItem(moduleUrl, actions, item, id);
export const deleteVehicleSubcategory = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);

export const clearAll = () => defaultActions.clearAll(actions);
export const clearVehicleSubcategory = () => defaultActions.clearItem(actions);
export const clearErrors = () => defaultActions.clearErrors(actions);

export const getFilters = () => defaultActions.getFilters(moduleUrl, actions);
export const setFilter = (filters: any) => defaultActions.setFilters(filters, actions);
